// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8394bd07","455":"5b9b9bfc","977":"38279bb9"}[chunkId] + ".chunk.js";
};